import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import React from "react";
import { getRecipeSignedUrl } from "./DigitalRecipePortal";

const RecipeFDTCategoryItems = ({
  tCount,
  scategory,
  scategoryIndex,
  containersOptionsArray,
  containerOptions,
  handleAdminTreatTreatCheck,
  showImagePDF,
  flavors,
}) => {
  return (
    <div className="rounded-md bg-white">
      <div className="card-header-border bg-white sticky">
        <div className="grid grid-cols-2 divide-x-0 text-card-header ">
          <div
            sx={{ width: 8 - `${tCount}` }}
            className="pl-2 text-card-header"
          >
            <h6 className="text-card-header my-5 ">
              {scategory.base_product_type_name}
            </h6>
          </div>
        </div>
      </div>
      <div className="flow-root">
        <ul
          key={scategory?.base_product_type_id}
          className="divide-gray-200 dark:divide-gray-700"
        >
          {scategory?.flavors.map((flv, flavorIndex) => {
            return (
              <li key={flv?.intFlavorID}>
                <div className="grid grid-cols-2 divide-x-0 card-item-style  pl-2">
                  <div
                    sx={{
                      width: 8 - `${tCount}` / 8,
                    }}
                    className="w-full pt-3 "
                    style={{ display: "flex" }}
                  >
                    <span
                      className="flex-shrink-0 w-7"
                      style={{
                        // display: "inline-block",
                        verticalAlign: "bottom",
                      }}
                    >
                      <img
                        className="rounded-full"
                        src={getRecipeSignedUrl(flv.thumbnailURL)}
                        onError={(event) => {
                          event.target.src = "./assets/icons/circle.png";
                          event.onerror = null;
                        }}
                        alt="Flvimage"
                      />

                      <Checkbox
                        onChange={(e) =>
                          handleAdminTreatTreatCheck(
                            e,
                            flavors?.all_flavors?.length - 1,
                            scategoryIndex,
                            flv?.intFlavorID,
                            "favourite"
                          )
                        }
                        checked={flv?.favourite}
                        style={{
                          position: "absolute",
                          marginTop: "-40px",
                          marginLeft: "10px",
                        }}
                        size="small"
                        icon={<FavoriteBorder className="text-gray-300" />}
                        checkedIcon={<Favorite color="error" />}
                      />
                    </span>
                    <span
                      style={{
                        fontSize: "12.5px",

                        paddingLeft: "13px",
                        paddingTop: "6px",
                      }}
                    >
                      {flv?.flavor_name}
                    </span>
                  </div>
                  <div
                    sx={{
                      width: `${tCount}` / 8,
                    }}
                  >
                    <div
                      className={`grid mt-2 text-center`}
                      style={{
                        gridTemplateColumns: `repeat(${containersOptionsArray?.length},1fr)`,
                      }}
                    >
                      {containerOptions.QC && (
                        <div
                          onClick={(e) => showImagePDF(flv?.quarterContainer)}
                          style={{
                            marginTop: "8px",
                            color:
                              flv?.quarterContainer &&
                              flv?.quarterContainer !== "NA"
                                ? "#0000EE"
                                : "darkgrey",
                            cursor:
                              flv?.quarterContainer &&
                              flv?.quarterContainer !== "NA"
                                ? "pointer"
                                : "not-allowed",
                          }}
                        >
                          QC
                        </div>
                      )}
                      {containerOptions.HC && (
                        <div
                          onClick={(e) => showImagePDF(flv?.halfContainer)}
                          style={{
                            marginTop: "8px",
                            color:
                              flv?.halfContainer && flv?.halfContainer !== "NA"
                                ? "#0000EE"
                                : "darkgrey",
                            cursor:
                              flv?.halfContainer && flv?.halfContainer !== "NA"
                                ? "pointer"
                                : "not-allowed",
                          }}
                        >
                          HC
                        </div>
                      )}
                      {containerOptions.SC && (
                        <div
                          onClick={(e) => showImagePDF(flv?.singleContainer)}
                          style={{
                            marginTop: "8px",
                            color:
                              flv?.singleContainer &&
                              flv?.singleContainer !== "NA"
                                ? "#0000EE"
                                : "darkgrey",
                            cursor:
                              flv?.singleContainer &&
                              flv?.singleContainer !== "NA"
                                ? "pointer"
                                : "not-allowed",
                          }}
                        >
                          SC
                        </div>
                      )}
                      {containerOptions.DC && (
                        <div
                          onClick={(e) => showImagePDF(flv?.doubleContainer)}
                          style={{
                            marginTop: "8px",
                            color:
                              flv?.doubleContainer &&
                              flv?.doubleContainer !== "NA"
                                ? "#0000EE"
                                : "darkgrey",
                            cursor:
                              flv?.doubleContainer &&
                              flv?.doubleContainer !== "NA"
                                ? "pointer"
                                : "not-allowed",
                          }}
                        >
                          DC
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default RecipeFDTCategoryItems;
